import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { B } from './UI';

const ADMIN_NAV = [
  { path: '/dashboard', label: 'Dashboard' },
  { path: '/jobs', label: 'Jobs' },
  { path: '/crew', label: 'Crew' },
  { path: '/materials', label: 'Materials' },
  { path: '/invoices', label: 'Invoices' },
  { path: '/customers', label: 'Customers' },
  { path: '/settings', label: 'Settings' },
];
const CUSTOMER_NAV = [{ path: '/my-projects', label: 'My Projects' }];

export default function Topbar() {
  const { profile, signOut, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const nav = isAdmin ? ADMIN_NAV : CUSTOMER_NAV;

  async function handleSignOut() {
    await signOut();
    navigate('/login');
  }

  return (
    <nav style={{
      background: B.navy, display: 'flex', alignItems: 'center',
      height: 54, padding: '0 1.25rem', position: 'sticky', top: 0, zIndex: 200, flexShrink: 0,
    }}>
      {/* Logo */}
      <div
        onClick={() => navigate(isAdmin ? '/dashboard' : '/my-projects')}
        style={{ display: 'flex', alignItems: 'center', gap: 10, marginRight: 20, cursor: 'pointer' }}
      >
        <div style={{ width: 32, height: 32, background: B.amber, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0 }}>🦅</div>
        <div>
          <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 800, color: '#fff', lineHeight: 1, letterSpacing: '.05em' }}>NIGHTHAWK</div>
          <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 8, color: B.amber, letterSpacing: '.16em', lineHeight: 1 }}>ROOFING</div>
        </div>
      </div>

      {/* Nav links */}
      <div style={{ display: 'flex', gap: 2, flex: 1, overflowX: 'auto' }}>
        {nav.map(n => {
          const active = location.pathname.startsWith(n.path);
          return (
            <button
              key={n.path}
              onClick={() => navigate(n.path)}
              style={{
                background: active ? 'rgba(245,158,11,.18)' : 'transparent',
                color: active ? B.amber : '#94A3B8',
                border: 'none', padding: '6px 13px', borderRadius: 8,
                fontSize: 13, fontWeight: 600, cursor: 'pointer',
                fontFamily: "'Barlow', sans-serif", whiteSpace: 'nowrap',
                transition: 'background .15s, color .15s',
              }}
            >
              {n.label}
            </button>
          );
        })}
      </div>

      {/* Right side */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ fontSize: 12, color: '#CBD5E1' }}>{profile?.full_name || profile?.email}</span>
        <button
          onClick={handleSignOut}
          style={{ background: 'rgba(255,255,255,.08)', color: '#94A3B8', border: '1px solid rgba(255,255,255,.12)', padding: '5px 10px', borderRadius: 7, fontSize: 11, cursor: 'pointer', fontFamily: "'Barlow', sans-serif" }}
        >
          Sign out
        </button>
      </div>
    </nav>
  );
}
